(function(){
    var root = document.getElementById('sec-recenzja');
    if (!root || root.dataset.lpReviewInit) return;
    root.dataset.lpReviewInit = '1';
    var toggle = root.querySelector('[data-review-toggle]');
    var body   = root.querySelector('[data-review-form-body]');
    if (toggle && body) {
      toggle.addEventListener('click', function(){
        var open = body.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Stars
    var stars = root.querySelectorAll('[data-star]');
    var ratingInput = root.querySelector('[data-review-rating]');
    stars.forEach(function(btn){
      btn.addEventListener('click', function(){
        var val = parseInt(btn.getAttribute('data-star'), 10);
        if (ratingInput) ratingInput.value = val;
        stars.forEach(function(b){ b.classList.toggle('is-filled', parseInt(b.getAttribute('data-star'),10) <= val); });
      });
    });
    // File upload preview (cosmetic — note: Shopify /contact nepřenáša súbory)
    var fileInput = root.querySelector('[data-review-file]');
    var uploadArea = root.querySelector('[data-review-upload]');
    if (fileInput && uploadArea) {
      var files = [];
      var uploadBtn = uploadArea.querySelector('.lp-review__upload-btn');
      function render(){
        uploadArea.querySelectorAll('.lp-review__preview').forEach(function(el){ el.remove(); });
        files.forEach(function(f, idx){
          var wrap = document.createElement('div'); wrap.className = 'lp-review__preview';
          var media = f.type.indexOf('video/') === 0 ? document.createElement('video') : document.createElement('img');
          media.src = f.data; media.className = 'lp-review__preview-media'; if (media.tagName === 'VIDEO') media.muted = true;
          wrap.appendChild(media);
          var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'lp-review__preview-remove'; rm.innerHTML = '×';
          rm.addEventListener('click', function(){ files.splice(idx,1); render(); });
          wrap.appendChild(rm);
          uploadArea.insertBefore(wrap, uploadBtn);
        });
        uploadBtn.style.display = files.length >= 3 ? 'none' : '';
      }
      fileInput.addEventListener('change', function(){
        var list = Array.prototype.slice.call(fileInput.files);
        if (files.length + list.length > 3) { alert('Maksymalnie 3 pliki.'); fileInput.value=''; return; }
        list.forEach(function(file){
          if (file.size > 5*1024*1024) { alert('Plik ' + file.name + ' przekracza 5 MB.'); return; }
          var reader = new FileReader();
          reader.onload = function(ev){ files.push({ data: ev.target.result, type: file.type }); render(); };
          reader.readAsDataURL(file);
        });
        fileInput.value = '';
      });
    }
    // AJAX submit
    var form = document.getElementById('lp-review-form');
    if (form) {
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var submit = form.querySelector('.lp-review__submit');
        if (submit) { submit.disabled = true; submit.textContent = 'Wysyłanie...'; }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(function(){
            var card = root.querySelector('.lp-review');
            card.innerHTML = '<div class="lp-review__success"><strong>Dziękujemy za recenzję! 🎁</strong>Twoja opinia trafiła do nas — wkrótce wyślemy Ci małą niespodziankę.</div>';
          })
          .catch(function(){
            if (submit) { submit.disabled = false; submit.textContent = 'Vélemény elküldése'; }
            alert('Coś poszło nie tak. Spróbuj ponownie lub napisz do nas.');
          });
      });
    }
  })();

/* == doplnené zo sekcie lp-cloudy-product.liquid == */
/* ── Review Form Toggle + Stars + Upload ── */
  (function() {
    var toggleBtn = document.querySelector('[data-review-toggle]');
    var formBody = document.querySelector('[data-review-form-body]');
    var toggleText = document.querySelector('[data-review-toggle-text]');
    if (!toggleBtn || !formBody) return;

    toggleBtn.addEventListener('click', function() {
      var isOpen = formBody.classList.contains('is-open');
      formBody.classList.toggle('is-open', !isOpen);
      toggleBtn.classList.toggle('is-open', !isOpen);
      toggleText.textContent = isOpen ? 'Írj véleményt \u2709' : 'Bezárás';
      if (!isOpen) {
        setTimeout(function() {
          var guestRow = document.querySelector('[data-review-guest-fields]');
          var target = (guestRow && !guestRow.classList.contains('is-hidden')) ? guestRow : formBody.querySelector('.artmie-review-field');
          if (target) {
            var y = target.getBoundingClientRect().top + window.scrollY - 170;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }, 80);
      }
    });

    /* Star picker */
    var starBtns = document.querySelectorAll('[data-star]');
    var ratingInput = document.querySelector('[data-review-rating-value]');
    starBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(btn.getAttribute('data-star'));
        ratingInput.value = val;
        starBtns.forEach(function(b) {
          b.classList.toggle('is-filled', parseInt(b.getAttribute('data-star')) <= val);
        });
      });
    });

    /* File upload preview */
    var fileInput = document.querySelector('[data-review-file]');
    var uploadArea = document.querySelector('[data-review-upload-area]');
    if (!fileInput || !uploadArea) return;
    var uploadedFiles = [];
    fileInput.addEventListener('change', function(e) {
      var files = Array.from(e.target.files);
      if (uploadedFiles.length + files.length > 3) { alert('Maximum 3 fájl.'); fileInput.value = ''; return; }
      files.forEach(function(file) {
        if (file.size > 5 * 1024 * 1024) { alert('A(z) „' + file.name + '" fájl nagyobb mint 5 MB.'); return; }
        var reader = new FileReader();
        reader.onload = function(ev) { uploadedFiles.push({ name: file.name, data: ev.target.result, type: file.type }); renderPreviews(); };
        reader.readAsDataURL(file);
      });
      fileInput.value = '';
    });
    function renderPreviews() {
      uploadArea.querySelectorAll('.artmie-review-preview-item').forEach(function(el) { el.remove(); });
      var uploadBtn = uploadArea.querySelector('.artmie-review-upload-btn');
      uploadBtn.style.display = uploadedFiles.length >= 3 ? 'none' : '';
      uploadedFiles.forEach(function(f, idx) {
        var wrap = document.createElement('div'); wrap.className = 'artmie-review-preview-item';
        if (f.type.startsWith('video/')) {
          var vid = document.createElement('video'); vid.src = f.data; vid.className = 'artmie-review-preview-media'; vid.muted = true; wrap.appendChild(vid);
        } else {
          var img = document.createElement('img'); img.src = f.data; img.className = 'artmie-review-preview-media'; img.alt = f.name; wrap.appendChild(img);
        }
        var removeBtn = document.createElement('button'); removeBtn.type = 'button'; removeBtn.className = 'artmie-review-preview-remove'; removeBtn.innerHTML = '\u00d7';
        removeBtn.addEventListener('click', function() { uploadedFiles.splice(idx, 1); renderPreviews(); });
        wrap.appendChild(removeBtn);
        uploadArea.insertBefore(wrap, uploadBtn);
      });
    }

    /* Form submit — send via fetch, show thank-you message */
    var reviewForm = document.getElementById('artmie-review-form');
    if (reviewForm) {
      reviewForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(reviewForm);
        var submitBtn = reviewForm.querySelector('.artmie-review-submit');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Küldés folyamatban...';

        fetch(reviewForm.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'text/html' }
        }).then(function() {
          /* Hide form, show thank-you */
          formBody.classList.remove('is-open');
          toggleBtn.classList.remove('is-open');
          toggleText.textContent = 'Írj véleményt \u2709';

          var thanks = document.createElement('div');
          thanks.className = 'artmie-review-success';
          thanks.innerHTML = '<strong>Köszönjük a véleményedet!</strong><br>Megkaptuk az értékelésedet. Hamarosan jelentkezünk egy kis meglepetéssel. \ud83c\udf81';
          var section = document.getElementById('write-review');
          section.appendChild(thanks);
          thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });

          /* Hide toggle button so user can't submit again */
          toggleBtn.style.display = 'none';
        }).catch(function() {
          submitBtn.disabled = false;
          submitBtn.textContent = 'VÉLEMÉNY KÜLDÉSE';
          alert('Hiba történt. Kérjük, próbáld újra.');
        });
      });
    }
  })();

;
(function() {
  // ═══════════════════════════════════════════
  //  lp-cloudy-product — single-variant page logic
  // ═══════════════════════════════════════════
  const variantIn   = document.getElementById('lp-variant-id');
  const qtyInput    = document.getElementById('lp-qty-input');
  const qtyVal      = document.getElementById('lp-qty-val');
  const qtyMinus    = document.getElementById('lp-qty-minus');
  const qtyPlus     = document.getElementById('lp-qty-plus');
  const addBtn      = document.getElementById('lp-add-btn');
  const buyBtn      = document.getElementById('lp-buy-btn');
  const heroForm    = document.getElementById('lp-product-form');
  const stickyBar   = document.getElementById('lp-sticky');
  const stickyBtn   = document.getElementById('lp-sticky-btn');
  const mainImgEl   = document.getElementById('lp-main-img');

  const VARIANT_ID = variantIn ? parseInt(variantIn.value, 10) : null;
  let quantity = 1;

  // ── QTY STEPPER ──
  function setQty(n) {
    quantity = Math.max(1, Math.min(999, n));
    if (qtyVal.tagName === 'INPUT') qtyVal.value = quantity; else qtyVal.textContent = quantity;
    qtyInput.value = quantity;
  }
  if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(quantity - 1));
  if (qtyPlus)  qtyPlus.addEventListener('click', () => setQty(quantity + 1));

  /* lp-qty-editable — množstvo sa dá napísať, nielen naklikať.
     #lp-qty-val je v sekciách <input>; staršie sekcie mali <span>, preto vieme oboje. */
  (function () {
    if (!qtyVal) return;
    var jeInput = qtyVal.tagName === 'INPUT';
    if (jeInput) {
      qtyVal.setAttribute('maxlength', '4');
    } else {
      qtyVal.setAttribute('contenteditable', 'true');
      qtyVal.setAttribute('inputmode', 'numeric');
      qtyVal.style.outline = 'none';
      qtyVal.style.minWidth = '2.2em';
    }
    function citaj() { return (jeInput ? qtyVal.value : qtyVal.textContent) || ''; }
    function pis(s) { if (jeInput) qtyVal.value = s; else qtyVal.textContent = s; }
    qtyVal.addEventListener('input', function () {
      /* pri písaní neorezávame na 999 — z „1000" by ticho vzniklo „100";
         necháme dopísať a zastropujeme až pri opustení poľa */
      var digits = citaj().replace(/[^0-9]/g, '').slice(0, 4);
      if (digits !== citaj()) pis(digits);
      var n = parseInt(digits, 10);
      if (n >= 1) { quantity = Math.min(999, n); qtyInput.value = quantity; }
    });
    qtyVal.addEventListener('change', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('blur', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); qtyVal.blur(); }
    });
  })();

  // ── GALLERY refs (potrebné pre lightbox + fly-to-cart) ──
  const stage      = document.getElementById('lp-stage');
  const stageImgs  = stage ? Array.from(stage.querySelectorAll('.lp-stage__img')) : [];
  const thumbs     = document.querySelectorAll('.lp-thumb');
  const arrowPrev  = document.getElementById('lp-arrow-prev');
  const arrowNext  = document.getElementById('lp-arrow-next');
  const progressBar= document.getElementById('lp-mobile-progress-bar');
  let currentIdx   = 0;
  function activeStageImg() {
    return stageImgs.find(im => im.classList.contains('active')) || mainImgEl;
  }

  // ── FLY-TO-CART ──
  function flyToCart(fromEl) {
    try {
      let cart = null;
      const sels = ['.cart-drawer__button', '.header-actions__action', '#cart-icon-bubble',
                    '.cart-count-bubble', 'a[href$="/cart"]', 'a[href="/cart"]'];
      for (const s of sels) {
        const els = document.querySelectorAll(s);
        for (const el of els) {
          const r = el.getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.top < 200 && r.left > window.innerWidth / 2) { cart = el; break; }
        }
        if (cart) break;
      }
      if (!cart || !fromEl) return;
      const s = fromEl.getBoundingClientRect();
      const e = cart.getBoundingClientRect();
      const fly = document.createElement('img');
      const act = activeStageImg();
      fly.src = (act && act.src) ? act.src : (mainImgEl ? mainImgEl.src : '');
      fly.style.cssText =
        'position:fixed;z-index:99999;pointer-events:none;object-fit:cover;border-radius:12px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.35);width:90px;height:90px;' +
        'left:' + (s.left + s.width/2 - 45) + 'px;top:' + (s.top + s.height/2 - 45) + 'px;' +
        'transition:left .85s cubic-bezier(.5,-0.25,.7,1),top .85s cubic-bezier(.5,-0.25,.7,1),' +
        'width .85s ease,height .85s ease,opacity .85s ease,transform .85s ease;';
      document.body.appendChild(fly);
      requestAnimationFrame(() => {
        fly.style.left = (e.left + e.width/2 - 14) + 'px';
        fly.style.top  = (e.top + e.height/2 - 14) + 'px';
        fly.style.width = '28px';
        fly.style.height = '28px';
        fly.style.opacity = '.35';
        fly.style.transform = 'rotate(22deg)';
      });
      setTimeout(() => {
        fly.remove();
        if (cart) { cart.style.transition = 'transform .3s cubic-bezier(.34,1.6,.64,1)'; cart.style.transform = 'scale(1.25)'; setTimeout(() => cart.style.transform = '', 320); }
      }, 880);
    } catch (err) {}
  }

  const CART_ICON  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polyline points="20 6 9 17 4 12"/></svg>';

  // ── ADD TO CART (AJAX) ──
  if (heroForm && addBtn) {
    heroForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!VARIANT_ID) return;
      addBtn.classList.add('loading'); addBtn.disabled = true;
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: VARIANT_ID, quantity: quantity}) })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok }) => {
        addBtn.classList.remove('loading');
        if (!ok) { addBtn.disabled = false; return; }
        flyToCart(addBtn);
        addBtn.classList.add('success');
        addBtn.querySelector('.lp-btn-cart-text').innerHTML = CHECK_ICON + ' Kosárba helyezve!';
        setTimeout(() => {
          addBtn.classList.remove('success'); addBtn.disabled = false;
          addBtn.querySelector('.lp-btn-cart-text').innerHTML = CART_ICON + ' Kosárba';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 2200);
      })
      .catch(() => { addBtn.classList.remove('loading'); addBtn.disabled = false; });
    });
  }

  // ── BUY NOW (priamo na checkout) ──
  if (buyBtn) {
    buyBtn.addEventListener('click', function() {
      if (!VARIANT_ID) return;
      buyBtn.disabled = true;
      buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="animation:lp-spin .7s linear infinite;width:16px;height:16px"><circle cx="12" cy="12" r="10" opacity=".25"/><path d="M22 12a10 10 0 0 1-10 10"/></svg> ...';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: VARIANT_ID, quantity: quantity}) })
      .then(r => {
        if (!r.ok) {
          buyBtn.disabled = false;
          buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Vásárlás most';
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(() => { buyBtn.disabled = false; buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Vásárlás most'; });
    });
  }

  // ── STICKY BAR (zobraz až keď buyBtn vyscrollne nahor) ──
  let stickyTicking = false;
  function injectChatShadowStyle(css) {
    const root = document.getElementById('artmie-chatbot-root');
    if (!root || !root.shadowRoot) return false;
    let s = root.shadowRoot.querySelector('style[data-lp-injected]');
    if (!s) { s = document.createElement('style'); s.setAttribute('data-lp-injected', '1'); root.shadowRoot.appendChild(s); }
    s.textContent = css;
    return true;
  }
  function updateChatOffset(show) {
    if (!window.matchMedia('(max-width: 768px)').matches) {
      injectChatShadowStyle(':host { transform: none !important; }');
      const r = document.getElementById('artmie-chatbot-root');
      if (r) r.style.removeProperty('transform');
      return;
    }
    const css = show
      ? ':host { transform: translateY(-72px) !important; transition: transform .25s ease !important; }'
      : ':host { transform: none !important; transition: transform .25s ease !important; }';
    injectChatShadowStyle(css);
    const root = document.getElementById('artmie-chatbot-root');
    if (root) {
      root.style.transition = 'transform .25s ease';
      if (show) root.style.setProperty('transform', 'translateY(-72px)', 'important');
      else root.style.removeProperty('transform');
    }
  }
  function updateSticky() {
    if (!buyBtn || !stickyBar) { stickyTicking = false; return; }
    const rect = buyBtn.getBoundingClientRect();
    const show = rect.bottom < 0;
    stickyBar.classList.toggle('show', show);
    document.body.classList.toggle('lp-has-sticky', show);
    updateChatOffset(show);
    stickyTicking = false;
  }
  (function watchChatRoot(){
    if (document.getElementById('artmie-chatbot-root')) { updateChatOffset(document.body.classList.contains('lp-has-sticky')); return; }
    const mo = new MutationObserver(() => {
      if (document.getElementById('artmie-chatbot-root')) {
        mo.disconnect();
        updateChatOffset(document.body.classList.contains('lp-has-sticky'));
      }
    });
    mo.observe(document.body, { childList: true });
    setTimeout(() => mo.disconnect(), 30000);
  })();
  window.addEventListener('scroll', () => {
    if (!stickyTicking) { requestAnimationFrame(updateSticky); stickyTicking = true; }
  }, { passive: true });
  updateSticky();

  // ── STICKY BAR — add to cart ──
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      if (!VARIANT_ID) return;
      const original = stickyBtn.innerHTML;
      stickyBtn.disabled = true;
      stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="animation:lp-spin .7s linear infinite;width:16px;height:16px"><circle cx="12" cy="12" r="10" opacity=".25"/><path d="M22 12a10 10 0 0 1-10 10"/></svg><span>...</span>';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: VARIANT_ID, quantity: quantity}) })
        .then(r => ({ ok: r.ok }))
        .then(({ ok }) => {
          if (!ok) { stickyBtn.innerHTML = original; stickyBtn.disabled = false; return; }
          flyToCart(stickyBtn);
          stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="width:16px;height:16px"><polyline points="20 6 9 17 4 12"/></svg><span>W koszyku!</span>';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { stickyBtn.innerHTML = original; stickyBtn.disabled = false; }, 2000);
        })
        .catch(() => { stickyBtn.innerHTML = original; stickyBtn.disabled = false; });
    });
  }

  // ── REELS — lazy load video ──
  const reels = document.querySelectorAll('.lp-reel');
  reels.forEach(reel => {
    const src = reel.dataset.src;
    const soundBtn = reel.querySelector('.lp-reel__sound');
    const soundOn  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
    const soundOff = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
    let video = null;
    if (!src || src.length === 0) { reel.style.cursor = 'default'; return; }
    function ensureVideo() {
      if (video) return video;
      const poster = reel.querySelector('img');
      video = document.createElement('video');
      video.src = src; video.muted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'none';
      if (poster) video.poster = poster.src;
      reel.replaceChild(video, poster);
      new IntersectionObserver(entries => {
        entries.forEach(e => { if (!e.isIntersecting && !video.paused) video.pause(); });
      }, { threshold: 0.2 }).observe(reel);
      video.addEventListener('play', () => reel.classList.add('playing'));
      video.addEventListener('pause', () => reel.classList.remove('playing'));
      return video;
    }
    reel.addEventListener('click', (ev) => {
      if (ev.target.closest('.lp-reel__sound')) return;
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {}); else v.pause();
    });
    if (soundBtn) soundBtn.addEventListener('click', (ev) => {
      ev.stopPropagation();
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {});
      v.muted = !v.muted;
      soundBtn.innerHTML = v.muted ? soundOff : soundOn;
    });
  });

  // ── GALÉRIA — thumb nav arrows ──
  const thumbsBox = document.getElementById('lp-thumbs');
  const thumbUp   = document.getElementById('lp-thumb-up');
  const thumbDown = document.getElementById('lp-thumb-down');
  if (thumbsBox && thumbUp && thumbDown) {
    const STEP = 204;
    function updateThumbNav() {
      const scrollable = thumbsBox.scrollHeight > thumbsBox.clientHeight + 2;
      const atTop = thumbsBox.scrollTop <= 2;
      const atBottom = thumbsBox.scrollTop + thumbsBox.clientHeight >= thumbsBox.scrollHeight - 2;
      thumbUp.hidden = !scrollable || atTop;
      thumbDown.hidden = !scrollable || atBottom;
    }
    thumbUp.addEventListener('click', () => thumbsBox.scrollBy({ top: -STEP, behavior: 'smooth' }));
    thumbDown.addEventListener('click', () => thumbsBox.scrollBy({ top: STEP, behavior: 'smooth' }));
    thumbsBox.addEventListener('scroll', updateThumbNav, { passive: true });
    window.addEventListener('resize', updateThumbNav);
    updateThumbNav();
  }

  // ── GALÉRIA — cross-slide ──
  function updateGalleryControls(idx) {
    if (arrowPrev) arrowPrev.toggleAttribute('disabled', false);
    if (arrowNext) arrowNext.toggleAttribute('disabled', false);
    if (progressBar && thumbs.length) {
      const n = (stageImgs && stageImgs.length) ? stageImgs.length : thumbs.length;
      if (n > 0) {
        progressBar.style.width = (100 / n) + '%';
        progressBar.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
    }
  }
  let slideBusy = false;
  function goToThumb(idx, dir) {
    if (idx < 0 || idx >= stageImgs.length) return;
    if (idx === currentIdx) {
      thumbs.forEach(x => x.classList.remove('active'));
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      updateGalleryControls(idx);
      return;
    }
    if (slideBusy) return;
    if (!dir) dir = idx > currentIdx ? 'next' : 'prev';
    const oldImg = stageImgs[currentIdx];
    const newImg = stageImgs[idx];
    const prepClass = dir === 'next' ? 'prep-right' : 'prep-left';
    newImg.classList.remove('active','out-left','out-right','prep-left','prep-right');
    newImg.classList.add(prepClass);
    void newImg.offsetWidth;
    slideBusy = true;
    requestAnimationFrame(() => {
      newImg.classList.remove(prepClass);
      newImg.classList.add('active');
      oldImg.classList.remove('active');
      oldImg.classList.add(dir === 'next' ? 'out-left' : 'out-right');
    });
    setTimeout(() => {
      stageImgs.forEach((im, i) => {
        if (i !== idx) {
          im.classList.remove('active','out-left','out-right','prep-left');
          im.classList.add('prep-right');
        }
      });
      slideBusy = false;
    }, 460);
    currentIdx = idx;
    thumbs.forEach(x => x.classList.remove('active'));
    if (thumbs[idx]) thumbs[idx].classList.add('active');
    updateGalleryControls(idx);
    try { if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior:'smooth', block:'nearest', inline:'nearest' }); } catch(e){}
  }
  thumbs.forEach((t, idx) => { t.addEventListener('click', () => goToThumb(idx)); });
  function currentThumbIdx(){
    let i = 0;
    thumbs.forEach((t, k) => { if (t.classList.contains('active')) i = k; });
    return i;
  }
  if (arrowPrev) arrowPrev.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i - 1 + thumbs.length) % thumbs.length;
    goToThumb(next, 'prev');
  });
  if (arrowNext) arrowNext.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i + 1) % thumbs.length;
    goToThumb(next, 'next');
  });
  updateGalleryControls(0);

  // ── SWIPE na hlavnej fotke ──
  (function(){
    if (!stage) return;
    let sx = 0, sy = 0, sw = false;
    function start(e){ const t = e.touches ? e.touches[0] : e; sx = t.clientX; sy = t.clientY; sw = true; }
    function end(e){
      if (!sw) return; sw = false;
      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const i = currentIdx, n = thumbs.length;
      if (n < 2) return;
      if (dx < 0)      goToThumb((i + 1) % n, 'next');
      else if (dx > 0) goToThumb((i - 1 + n) % n, 'prev');
    }
    stage.addEventListener('touchstart', start, { passive: true });
    stage.addEventListener('touchend',   end,   { passive: true });
  })();

  // ── FAQ accordion ──
  document.querySelectorAll('.lp-faq__item .lp-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.lp-faq__item');
      item.classList.toggle('open');
    });
  });

  // ── SECTION TABS — smooth scroll + active ──
  (function(){
    const tabs = document.querySelectorAll('.lp-tab');
    if (!tabs.length) return;
    const targets = Array.from(tabs).map(t => ({ tab: t, id: t.dataset.target, el: document.getElementById(t.dataset.target) })).filter(x => x.el);
    tabs.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        const id = t.dataset.target;
        const el = document.getElementById(id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
    function updateActive() {
      const mid = window.scrollY + window.innerHeight * 0.30;
      let active = targets[0];
      for (const t of targets) { if (t.el.offsetTop <= mid) active = t; }
      tabs.forEach(x => x.classList.toggle('active', x === active.tab));
    }
    let tick = false;
    window.addEventListener('scroll', () => {
      if (!tick) { requestAnimationFrame(() => { updateActive(); tick = false; }); tick = true; }
    }, { passive: true });
    updateActive();
  })();

  // ── LIGHTBOX ──
  const lightbox      = document.getElementById('lp-lightbox');
  const lightboxImg   = document.getElementById('lp-lightbox-img');
  const lightboxClose = document.getElementById('lp-lightbox-close');
  if (lightbox && lightboxImg && stage) {
    let sxL = 0, syL = 0;
    stage.addEventListener('touchstart', e => { const t = e.touches[0]; sxL = t.clientX; syL = t.clientY; }, { passive: true });
    function openLightbox(e) {
      if (e && e.changedTouches) {
        const t = e.changedTouches[0];
        if (Math.abs(t.clientX - sxL) > 10 || Math.abs(t.clientY - syL) > 10) return;
      }
      const act = activeStageImg();
      lightboxImg.src = act ? act.src : '';
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    }
    stage.addEventListener('click', openLightbox);
    lightbox.addEventListener('click', closeLightbox);
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
  }
})();
/* wideo montażu — iframe až po kliknutí (facade) */
(function(){var bs=document.querySelectorAll(".lp-video__btn[data-yt]");if(!bs.length)return;bs.forEach(function(b){b.addEventListener("click",function(){var f=document.createElement("iframe");f.src="https://www.youtube-nocookie.com/embed/"+b.getAttribute("data-yt")+"?autoplay=1&rel=0";f.title=b.getAttribute("data-yt-title")||"";f.allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";f.allowFullscreen=!0;f.loading="lazy";b.parentNode.replaceChild(f,b);f.focus()})})})();

/* video v galérii — iframe prekryje stage; thumbnaily aj šípky cyklujú fotky ↔ video */
(function(){var th=document.querySelector(".lp-thumb--video"),stage=document.getElementById("lp-stage");if(!th||!stage)return;
var all=Array.prototype.slice.call(document.querySelectorAll(".lp-thumb")),box=null;
function close(){if(box){box.remove();box=null}}
function open(){all.forEach(function(t){t.classList.remove("active")});th.classList.add("active");if(box)return;
box=document.createElement("iframe");box.className="lp-stage__yt";
box.src="https://www.youtube-nocookie.com/embed/"+th.getAttribute("data-yt")+"?autoplay=1&rel=0";
box.title="Az atelier MY HOME festőállvány összeszerelése";box.loading="lazy";box.allowFullscreen=!0;
box.allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
stage.appendChild(box)}
th.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();open()},!0);
all.forEach(function(t){if(t!==th)t.addEventListener("click",close)});
function cur(){var i=0;all.forEach(function(t,k){if(t.classList.contains("active"))i=k});return i}
function step(d){var n=all.length;if(n<2)return;var t=all[(cur()+d+n)%n];if(t===th){open()}else{close();t.click()}}
[["lp-arrow-prev",-1],["lp-arrow-next",1]].forEach(function(p){var a=document.getElementById(p[0]);if(!a)return;
var c=a.cloneNode(!0);a.parentNode.replaceChild(c,a);
c.addEventListener("click",function(e){e.preventDefault();step(p[1])})});
(function(){var sx=0,sw=!1;stage.addEventListener("touchstart",function(e){sx=e.touches[0].clientX;sw=!0},{passive:!0});
stage.addEventListener("touchend",function(e){if(!sw)return;sw=!1;var dx=e.changedTouches[0].clientX-sx;
if(Math.abs(dx)>40&&box){close();step(dx<0?1:-1)}},{passive:!0})})()})();
